import React, { useState, useEffect } from 'react';
import LanguageSwitcher from './LanguageSwitcher';
import Lottie from 'lottie-react';

const LayoutHeader = ({ onNavigate = () => {}, onLanguageChange = () => {}, currentLanguage = 'en', translations = {} }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [sunData, setSunData] = useState(null);

  useEffect(() => {
    fetch('/images/sun.json')
      .then(res => res.json())
      .then(data => setSunData(data))
      .catch(err => console.error('Error loading sun animation:', err));
  }, []);

  const navItems = [
    { id: 'home', label: translations.home || 'Home' },
    { id: 'essence', label: translations.ourEssence || 'Our Essence' },
    { id: 'menu', label: translations.menu || 'Menu' },
    { id: 'ambience', label: translations.ambience || 'Ambience' },
    { id: 'gallery', label: translations.gallery || 'Gallery' },
    { id: 'contact', label: translations.contact || 'Contact' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMenuItemClick = (id) => {
    onNavigate(id);
    setIsMenuOpen(false);
  };

  return (
    <header className={`fixed w-full z-50 transition-all duration-300 ease-in-out ${isSticky ? 'bg-white shadow-lg py-2' : 'bg-transparent py-4'}`}>
      <div className="container mx-auto flex justify-between items-center px-4">
        {/* Logo compacto */}
        <div className="flex items-center flex-shrink-0">
          {sunData && (
            <div className="w-12 h-12">
              <Lottie 
                animationData={sunData}
                loop={true}
                autoplay={true}
              />
            </div>
          )}
          <h1 className="text-xl font-bold text-[#FF4C29] whitespace-nowrap ml-2">
            EL LATINO
          </h1>
        </div>

        {/* Navegación desktop */}
        <nav className="hidden md:flex items-center space-x-4 ml-4">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleMenuItemClick(item.id)}
              className="text-sm text-gray-700 hover:text-[#FF4C29] font-medium transition-colors duration-200 whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* Selector de idiomas compacto */}
        <div className="flex items-center space-x-2">
          <div className="scale-75 md:scale-90 origin-right">
            <LanguageSwitcher 
              currentLanguage={currentLanguage} 
              onLanguageChange={onLanguageChange} 
              compact 
            />
          </div>
          
          {/* Botón menú móvil */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)} 
            className="md:hidden text-gray-700 focus:outline-none ml-1"
            aria-label="Toggle menu"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Menú móvil */}
      {isMenuOpen && (
        <div className="md:hidden fixed inset-0 bg-white bg-opacity-95 z-40 flex flex-col items-center justify-center space-y-3 pt-16 animate-fade-in">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleMenuItemClick(item.id)}
              className="text-lg text-gray-800 hover:text-[#FF4C29] font-semibold transition-colors duration-200 px-4 py-1"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};

export default LayoutHeader;